import React from "react";
import Intro from "../../Components/Intro";
import one from "../../Assets/new/slide/new/strsn.webp";
import two from "../../Assets/new/slide/new/green.webp";
import three from "../../Assets/new/slide/new/sunshine.webp";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import QuoteCards from "../../Components/QuoteCards";
import AgreeServicess from "../../Components/AgreeServicess";
import Supplies from "../../Components/Supplies";
import CustomerExp from "../../Components/CustomersExp";
import "../../App.css";
import Enquiry from "../../Components/Enquiry";
import CustomSlider from "../../Components/CustomSlider";
import TestimonialsSlider from "../../Components/TestimonialsSlider";
import gif from "../../Assets/gi.webm";
import BgVid from "../../Assets/rvid.webm";
import front_page_poster from "../../Assets/front-page-poster.webp";
import { Helmet } from "react-helmet";

function Home() {
  var img = [
    {
      img: two,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "We Are India's Fastest Growing Hi-Tech Polyhouse (Hydroponics) Setup Company.",
      moto: "Build Your Own affordable Hydroponic Farm With Our Expertise (At home also)",
    },
    {
      img: one,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "We Are the largest project developer in hydroponic farming and soil-less farming.",
      moto: "The Best Harvests Anywhere In The World",
    },
    {
      img: three,
      caption: "ROYAL GREEN HOUSE CONSTRUCTION(I) PVT. LTD.",
      subcaption:
        "Leader In Vertical Hydroponic Farming With 40 To 60% Higher Revenue.",
      moto: "Build Extremely Profitable Hydroponic Farm With Us.",
    },
  ];
  return (
    <>
      <Helmet>
        {/* Preload poster for instant display */}
        <link rel="preload" as="image" href={front_page_poster} />
      </Helmet>

      {/* Lazy-loaded video appears after LCP */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* Lazy-loaded video with poster */}
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          poster={front_page_poster}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            transition: "opacity 0.5s ease-in-out",
          }}
          onLoadedData={(e) => {
            e.target.style.opacity = 1; // fade in
          }}
        >
          <source src={BgVid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay text */}
        <div
          id="contentVid"
          style={{
            position: "absolute",
            top: "3%",
            left: 0,
            padding: "20px",
            color: "white",
            width: "100%",
          }}
        >
          <div className="text-start py-5">
            <div className="my-lg-5 mx-lg-5 py-lg-5">
              <h1 className="text-regular">
                <span className="heading1 py-3">ROYAL GREEN HOUSE</span>
                <br />
                <span className="heading3 text-theme">
                  CONSTRUCTION(I) PVT. LTD.
                  <br />
                </span>
                <span className="heading3">We Are India's Fastest Growing</span>
                <br />
                <span>Hi-Tech</span> Polyhouse and Hydroponics farm Setup
                Company
                <br />
                <span className="heading6 text-theme mb-2">
                  Build Your Own Affordable Hydroponic Farm With Our Expertise
                  (At Home Also)
                  <br />
                </span>
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* <Banner /> */}
      {/* <Slider images={img} /> */}
      <QuoteCards />

      <Container className="whitebgimg p-4" fluid>
        <Row>
          <Col lg={6} className="p-4 mt-2">
            <h5 className="p-2 hover-text" style={{ display: "inline" }}>
              LEADER IN VERTICAL HYDROPONIC FARMING
            </h5>
            <h5 className="p-2 hover-text" style={{ display: "inline" }}>
              WITH 40 TO 60% HIGHER REVENUE.
            </h5>

            <h5 className="p-2 hover-text">
              WITH 5000 SQFT AREA ANYWHERE IN INDIA, YOU CAN BUILD AN EXTREMELY
              PROFITABLE HYDROPONIC FARM.
            </h5>
            <h5 className="p-2 hover-text">
              WE BUILD YOUR FARM – YOU OPERATE FARM{" "}
            </h5>
            <h3 className="p-2 text-green">
              More Details :<a href="tel:+919960991166"> +91-9960-991-166</a>
            </h3>
          </Col>
          <Col lg={4} className="p-4 mt-3">
            <video
              src={gif}
              autoPlay
              muted
              loop
              playsInline
              className="img-fluid rounded"
              style={{ maxWidth: "100%", height: "auto" }}
            >
              Your browser does not support the video tag.
            </video>
          </Col>
        </Row>
      </Container>

      {/* Text below the video */}
      <Container>
        <Row>
          <Col>
            <h5 className="text-start">
              Hi-Tech Polyhouse and Hydroponics Farm Setup in India
            </h5>
          </Col>
        </Row>
      </Container>
      <Intro />
      <Supplies />
      <AgreeServicess />
      {/* <GalleryofProjects /> */}
      <TestimonialsSlider />
      <CustomerExp reviewData="reviewData" />
      <CustomSlider />
      {/* <Press /> */}
      <Enquiry />
      {/* <PopupMessage /> */}
    </>
  );
}
export default Home;
